import React, { useState, useEffect, useMemo, useCallback } from "react";
import HireneuronTable from "../../../components/HireneuronTable_copy/HireneuronTable";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  FormGroup,
  Label,
  Badge,
} from "reactstrap";
import moment from "moment";

const LogManagement = () => {
  const [refresh, setRefresh] = useState(false);
  const [tableConfig, setTableConfig] = useState(null);
  const [filters, setFilters] = useState({
    productName: "",
    startDate: "",
    endDate: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    setTableConfig(null);
    setRefresh((prev) => !prev);
  };

  const resetFilters = () => {
    setFilters({ productName: "", startDate: "", endDate: "" });
    setRefresh((prev) => !prev);
  };

  const columns = useMemo(
    () => [
      { name: "File Name", label: "fileName", position: "start" },
      { name: "Candidate ID", label: "candidateId", position: "start" },
      { name: "Job ID", label: "jobId", position: "start" },
      {
        name: "Product",
        label: "productName",
        position: "start",
      },
      {
        name: 'Credit Deducted',
        label: 'creditDeducted',
        position: 'start',
      },
      {
        name: 'Status',
        label: 'status',
        position: 'start',
      },
      {
        name: "Date(timestamp)",
        label: "createdAt",
        position: "start",
        sort: true,
        displayFunction: (eachObject) => {
          return eachObject.createdAt
            ? moment(eachObject.createdAt).format("lll")
            : "NA";
        },
      },
    ],
    [],
  );

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const companyId = authUser?.companyId;

    const params = new URLSearchParams({ companyId });
    if (filters.productName) params.append("productName", filters.productName);
    if (filters.startDate)
      params.append("startDate", `${filters.startDate}T00:00:00Z`);
    if (filters.endDate)
      params.append("endDate", `${filters.endDate}T23:59:59Z`);

    const config = {
      tableKey: 10,
      apiUrl: `logs/get?${params.toString()}`,
      tableHeading: "AI Logs",
      searchButton: true,
      searchSuggestion: false,
      showHideColumn: true,
      pageSizes: [10, 20, 50, 100],
      defaultPageSizeIndex: 0,
      scroll: false,
      lazyLoading: false,
      columns: columns,
    };

    setTableConfig(config);
  }, [refresh, columns]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Header Section */}
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="mb-1 text-primary">Log Management</h4>
            <p className="text-muted mb-0">
              Monitor and audit AI processing activities.
            </p>
          </div>
        </div>

        {/* Filter Card */}
        <Row className="mb-4">
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <CardBody>
                <Row className="align-items-end">
                  <Col md={3}>
                    <FormGroup className="mb-md-0">
                      <Label className="font-weight-600 small text-uppercase text-muted">
                        Product
                      </Label>
                      <Input
                        type="select"
                        name="productName"
                        value={filters.productName}
                        className="form-control-light"
                        onChange={handleInputChange}
                      >
                        <option value="">All Products</option>
                        <option value="RESUME">Resume</option>
                        <option value="JD">JD</option>
                        <option value="MATCH">Match</option>
                        <option value="AI_INTERVIEW">AI Interview</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup className="mb-md-0">
                      <Label className="font-weight-600 small text-uppercase text-muted">
                        From Date
                      </Label>
                      <Input
                        type="date"
                        name="startDate"
                        value={filters.startDate}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup className="mb-md-0">
                      <Label className="font-weight-600 small text-uppercase text-muted">
                        To Date
                      </Label>
                      <Input
                        type="date"
                        name="endDate"
                        value={filters.endDate}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <Button
                      color="primary"
                      block
                      onClick={applyFilters}
                      className="btn-label waves-effect waves-light"
                    >
                      Filter Logs
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Table Section */}
        <Row>
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <CardBody>
                {tableConfig ? (
                  <HireneuronTable tableConfig={tableConfig} tableKey={10} />
                ) : (
                  <div className="py-5 text-center">
                    <div
                      className="spinner-border text-primary m-2"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted">Fetching your logs...</p>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LogManagement;
